import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
  if ('target' in node) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener');
  }
});

const normalizeNewlines = (content) => content?.replaceAll('\\n', '\n');

export const sanitizeDom = (html) => {
  if (!html) return null;

  const normalized = normalizeNewlines(html);

  const htmlWithBreaks = normalized.replace(/\n/g, '<br/>');

  return DOMPurify.sanitize(htmlWithBreaks);
};

export const normalizeText = (text) => {
  if (!text) return '';

  return normalizeNewlines(text);
};
